import { render, staticRenderFns } from "./ManageCertificates.vue?vue&type=template&id=4debbcd6&scoped=true&"
import script from "./ManageCertificates.vue?vue&type=script&lang=js&"
export * from "./ManageCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4debbcd6",
  null
  
)

export default component.exports